export default {
      id: "icon--plus-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "sprite.svg#icon--plus",
      toString: function () {
        return this.url;
      }
    }